import { Paper, Table, TableBody, TableCell, TableContainer, TableRow } from "@mui/material";
import { FormattedMessage } from "react-intl";

import { FormDialog } from "@dzambalaorg/mui-dialog-form";
import { IOnConfirmArgs, useApiCall } from "@dzambalaorg/react-hooks";
import type { IPredictionAnswer, IPredictionQuestion } from "@framework/types";

export interface IPredictionQuestionDialogViewProps {
  open: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  viewItem: IPredictionQuestion;
}

export const PredictionQuestionDialogView = (props: IPredictionQuestionDialogViewProps) => {
  const { viewItem, onConfirm, ...rest } = props;

  const { fn } = useApiCall(async (api, values) => {
    await api.fetchJson({
      url: "/prediction/answer",
      method: "POST",
      data: values,
    });
  });

  const handleConfirm = async ({ data }: IOnConfirmArgs<IPredictionAnswer>) => {
    await fn(void 0, data).finally(() => {
      onConfirm();
    });
  };

  return (
    <FormDialog initialValues={{}} message="dialogs.view" onExternalConfirm={handleConfirm as any} {...rest}>
      <TableContainer component={Paper}>
        <Table aria-label="raffle token table">
          <TableBody>
            <TableRow>
              <TableCell component="th" scope="row">
                <FormattedMessage id="form.labels.question" />
              </TableCell>
              <TableCell align="right">{viewItem.title}</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </FormDialog>
  );
};
